import * as R from 'remeda';
import { z } from 'zod';
import { DatapointColumn, RowModel } from '../rows/helpers';

export const resolveMessagesByPriority = (
  message: NonNullable<RowModel[DatapointColumn]>['messages'][number]
) => {
  const messagesByType = R.groupBy(message, m => m.type);

  return messagesByType.error || messagesByType.warning || messagesByType.info;
};

export const resolveMessagesPerDatapoints = ({
  messages,
  datapoints,
}: NonNullable<RowModel[DatapointColumn]>) => {
  const messagesSortedByDatapoints = datapoints.flatMap(
    ({ id }) => messages[String(id)] ?? []
  );

  return resolveMessagesByPriority(messagesSortedByDatapoints);
};

export const resolveAutomationBlockersPerDatapoints = ({
  datapoints,
  automationBlockers,
}: NonNullable<RowModel[DatapointColumn]>) => {
  const blockersSortedByDatapoints = datapoints.flatMap(
    ({ id }) => automationBlockers[String(id)] ?? []
  );

  return blockersSortedByDatapoints;
};

const queryIndexSchema = z
  .object({
    __query_index: z.number().optional(),
  })
  .passthrough();

export const getMatchedQueryIndex = (
  row: RowModel,
  currentFormulaColumn: DatapointColumn
): number | undefined => {
  const cell = row[currentFormulaColumn];
  const first = cell?.datapoints[0];
  const struct =
    first && 'content' in first && first.content?.struct != null
      ? first.content.struct
      : null;

  if (!struct) return undefined;

  const parsed = queryIndexSchema.safeParse(struct);
  return parsed.success ? parsed.data.__query_index : undefined;
};

export const isUnusedDependency = (
  row: RowModel,
  dependencySchemaId: string,
  dependenciesByQuery: string[][] | undefined,
  currentFormulaColumn: DatapointColumn
): boolean => {
  if (!dependenciesByQuery) return false;

  const matchedQueryIndex = getMatchedQueryIndex(row, currentFormulaColumn);

  return (
    matchedQueryIndex !== undefined &&
    !dependenciesByQuery[matchedQueryIndex]?.includes(dependencySchemaId)
  );
};
